import http from '@/utils/http';

const baseUrl = '/central-eventos';

export default {
    buscarEventos() {
        return http.get({
            url: baseUrl + `/buscar`,
            lockScreen: false
        });
    },

    visualizar(id) {
        return http.get({
            url: baseUrl + `/visualizar/${id}`,
            lockScreen: true,
            lockMessage: 'Marcando evento como visualizado'
        });
    }
};
